export const navbarStyles = {
  wrapper:
    'w-full fixed top-0 inset-x-0 z-50 bg-white/95 border-b border-gray-200 phone:border-none',
  nav: 'mx-auto max-w-7xl',
  userMenu: 'relative rounded-md p-2 text-brand-6',
  navItemsLayout: 'flex h-16 items-center px-2 w-full',
}
